<script lang="ts">
  import { Container, Row, Col } from "sveltestrap";
  import GithubButton from "../../components/GithubButton.svelte";
  import Feature from "../../components/landing/Feature.svelte";
  import { githubAppUrl } from "../../stores";
  import LearnMoreButton from "../../components/landing/LearnMoreButton.svelte";
</script>

<div class="works-section" id="how-it-works">
  <Container style="background: white;">
    <h2 class="titles">How it works</h2>
    <h5 class="subtitle">
      Use your Unity Cloud setup to run autmoated tests on Pull Requests
    </h5>

    <Feature
      imgData={{
        src: "./images/landing/create-pr.png",
        alt: "execution example",
      }}
      inverted
    >
      <h2>Create a <span>Pull Request</span></h2>
      <p>
        When you create a Pull Request, the Status check is notified and creates
        a build config in your Unity Cloud Account.
      </p>
    </Feature>
    <Feature
      imgData={{
        src: "./images/landing/feature_execution.png",
        alt: "execution example",
      }}
    >
      <h2>Let <span>Unity</span> Cloud Run</h2>
      <p>
        Unity Cloud will run your check and, through our system, it will report
        the result in your status check.
      </p>
    </Feature>

    <Feature
      imgData={{
        src: "./images/landing/merge-pr.png",
        alt: "execution example",
      }}
      inverted
    >
      <h2><span>Merge</span> Your Code With Confidence</h2>
      <p>
        Now you can merge your code with confidence knowing that you have a
        Continous Testing system setup in your Pull Requests
      </p>
    </Feature>

    <div class="more-info-section">
      <p style=" text-align: center;">
        Curious for more? Install the app and get started!
      </p>
      <Row class="h-100 justify-content-around align-items-center">
        <Col>
          <GithubButton githubUrl={$githubAppUrl} />
        </Col>
        <Col>
          <LearnMoreButton />
        </Col>
      </Row>
    </div>
  </Container>
</div>

<style>
  h2 {
    font-family: Montserrat;
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    line-height: 39px;

    /* identical to box height */
    text-transform: capitalize;

    color: #2f2e34;
  }

  .works-section {
    padding: 30px;
    display: flex;
    align-items: center;
    background-color: #FFFFFF;
  }

  h2 span {
    color: #3a9949;
  }

  .subtitle {
    font-family: Rubik;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 184%;

    /* or 33px */
    text-align: center;

    color: #2f2e34;

    opacity: 0.7;
  }

  p {
    font-family: Rubik;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 184%;

    /* or 33px */
    text-transform: capitalize;

    color: #2f2e34;

    opacity: 0.7;
    text-align: left;
  }

  .more-info-section {
    padding: 150px 50px 50px 50px;
  }
</style>
